<div class="modal-header">
  <h4>Change My PIN</h4>
  <button type="button" class="close-button" (click)="close()">×</button>
</div>
@if (!showPinUI) {
  <div>
    <div class="subtitle">Enter your new PIN for your IllumLive account.</div>
    <form [formGroup]="pinForm" class="password-form">
      <div class="form-group">
        <label for="currentPin">Current PIN</label>
        <div class="input-group">
          <input type="password" class="form-control" id="currentPin" formControlName="currentPin" readonly
            maxlength="4">
            <button type="button" class="btn btn-outline-secondary" (click)="openPinUI('CURRENT')">
              <i class="bi bi-key"></i>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="newPin">New PIN</label>
          <div class="input-group">
            <input type="password" class="form-control" id="newPin" formControlName="newPin" readonly maxlength="4">
            <button type="button" class="btn btn-outline-secondary" (click)="openPinUI('NEW')">
              <i class="bi bi-key"></i>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="confirmPin">Confirm New PIN</label>
          <div class="input-group">
            <input type="password" class="form-control" id="confirmPin" formControlName="confirmPin" readonly
              maxlength="4">
              <button type="button" class="btn btn-outline-secondary" (click)="openPinUI('CONFIRM')">
                <i class="bi bi-key"></i>
              </button>
            </div>
          </div>
          @if (error) {
            <div class="alert alert-danger">
              {{ error }}
            </div>
          }
          @if (responseError && !error) {
            <div class="alert alert-danger">
              {{ responseError }}
            </div>
          }
          <div class="form-actions">
            <button type="button" class="btn btn-primary" [disabled]="pinForm.invalid || showError()" (click)="save()">
              Save
            </button>
            <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
          </div>
        </form>
      </div>
    }

    @if (showPinUI) {
      <div class="pin-keypad">
        <div class="pin-display">
          <input type="password" class="form-control text-center" [value]="getCurrentPinControl()?.value || ''" readonly
            maxlength="4">
          </div>
          <div class="keypad-grid">
            @for (num of [1,2,3,4,5,6,7,8,9]; track num) {
              <button class="btn btn-outline-primary keypad-btn"
                (click)="onKeyPressed(num.toString())">
                {{ num }}
              </button>
            }
            <button class="btn btn-outline-primary keypad-btn" (click)="onKeyPressed('0')">0</button>
            <button class="btn btn-outline-danger keypad-btn" (click)="onKeyPressed('<')">
              <i class="bi bi-backspace"></i>
            </button>
          </div>
          <div class="form-actions">
            <button type="button" class="btn btn-primary" (click)="closePinUI()">Done</button>
            <button type="button" class="btn btn-secondary" (click)="closePinUI()">Cancel</button>
          </div>
        </div>
      }

      <!-- Success Modal Template -->
      <ng-template #successModal let-modal>
        <div class="modal-header success-header">
          <h4 class="modal-title">Success</h4>
        </div>
        <div class="modal-body">
          <p>{{ successMessage }}</p>
        </div>
        <div class="modal-footer success-footer">
          <button class="btn btn-primary" (click)="modal.close()">OK</button>
        </div>
      </ng-template>